// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/AwareEngine.proto" (package "aware", syntax proto3)
// tslint:disable
import { DeleteReminderRequest } from "./Event";
import { ScheduleReminderResponse } from "./Event";
import { ScheduleReminderRequest } from "./Event";
import { Person } from "./Person";
import { UserPersons } from "./Person";
import { UserPlaces } from "./Location";
import { ActivityInsights } from "./Insights";
import { UserActivityStatisticsList } from "./Event";
import { UserLocationStatistics } from "./Event";
import { EventConstraints } from "./Event";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { ActivityCategoryType } from "./Activity";
import { FaceRecognitionModel } from "./Skeleton";
import { ActivityEstimate } from "./Activity";
import { EventOperation } from "./Event";
import { UserScheduleStatus } from "./Event";
import { UserSchedule } from "./Event";
import { Duration } from "../../google/protobuf/duration";
import { Place } from "./Location";
import { SurfaceInfo } from "./AliveNet";
import { Event } from "./Event";
import { ActivityCategoryEstimate } from "./Activity";
import { GeolocationVelocity } from "./Location";
import { Geolocation } from "./Location";
import { ComputerSession } from "./ComputerEvents";
import { Workout } from "./Health";
import { SleepEvent } from "./Health";
import { LocationVisit } from "./Location";
import { LocationMeasurement } from "./Location";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf enum aware.UserSurfaceEvent.SurfaceEventType
 */
export var UserSurfaceEvent_SurfaceEventType;
(function (UserSurfaceEvent_SurfaceEventType) {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UserSurfaceEvent_SurfaceEventType[UserSurfaceEvent_SurfaceEventType["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * @generated from protobuf enum value: PRESENT = 1;
     */
    UserSurfaceEvent_SurfaceEventType[UserSurfaceEvent_SurfaceEventType["PRESENT"] = 1] = "PRESENT";
    /**
     * @generated from protobuf enum value: ENGAGED = 2;
     */
    UserSurfaceEvent_SurfaceEventType[UserSurfaceEvent_SurfaceEventType["ENGAGED"] = 2] = "ENGAGED";
    /**
     * @generated from protobuf enum value: DISENGAGED = 3;
     */
    UserSurfaceEvent_SurfaceEventType[UserSurfaceEvent_SurfaceEventType["DISENGAGED"] = 3] = "DISENGAGED";
    /**
     * @generated from protobuf enum value: ABSENT = 4;
     */
    UserSurfaceEvent_SurfaceEventType[UserSurfaceEvent_SurfaceEventType["ABSENT"] = 4] = "ABSENT";
})(UserSurfaceEvent_SurfaceEventType || (UserSurfaceEvent_SurfaceEventType = {}));
/**
 * @generated from protobuf enum aware.UserState.Type
 */
export var UserState_Type;
(function (UserState_Type) {
    /**
     * @generated from protobuf enum value: Unknown = 0;
     */
    UserState_Type[UserState_Type["Unknown"] = 0] = "Unknown";
    /**
     * @generated from protobuf enum value: Heartbeat = 1;
     */
    UserState_Type[UserState_Type["Heartbeat"] = 1] = "Heartbeat";
    /**
     * @generated from protobuf enum value: UserStateUpdate = 2;
     */
    UserState_Type[UserState_Type["UserStateUpdate"] = 2] = "UserStateUpdate";
    /**
     * @generated from protobuf enum value: RealtimeUpdate = 3;
     */
    UserState_Type[UserState_Type["RealtimeUpdate"] = 3] = "RealtimeUpdate";
})(UserState_Type || (UserState_Type = {}));
/**
 * @generated from protobuf enum aware.EventConstraintsResponse.CSPResult
 */
export var EventConstraintsResponse_CSPResult;
(function (EventConstraintsResponse_CSPResult) {
    /**
     * @generated from protobuf enum value: UnknownResult = 0;
     */
    EventConstraintsResponse_CSPResult[EventConstraintsResponse_CSPResult["UnknownResult"] = 0] = "UnknownResult";
    /**
     * @generated from protobuf enum value: Ok = 1;
     */
    EventConstraintsResponse_CSPResult[EventConstraintsResponse_CSPResult["Ok"] = 1] = "Ok";
    /**
     * @generated from protobuf enum value: Error = 2;
     */
    EventConstraintsResponse_CSPResult[EventConstraintsResponse_CSPResult["Error"] = 2] = "Error";
})(EventConstraintsResponse_CSPResult || (EventConstraintsResponse_CSPResult = {}));
/**
 * @generated from protobuf enum aware.CreateUserResponse.CreateUserStatus
 */
export var CreateUserResponse_CreateUserStatus;
(function (CreateUserResponse_CreateUserStatus) {
    /**
     * @generated from protobuf enum value: UnknownCreationStatus = 0;
     */
    CreateUserResponse_CreateUserStatus[CreateUserResponse_CreateUserStatus["UnknownCreationStatus"] = 0] = "UnknownCreationStatus";
    /**
     * @generated from protobuf enum value: Success = 1;
     */
    CreateUserResponse_CreateUserStatus[CreateUserResponse_CreateUserStatus["Success"] = 1] = "Success";
    /**
     * @generated from protobuf enum value: AccountExists = 2;
     */
    CreateUserResponse_CreateUserStatus[CreateUserResponse_CreateUserStatus["AccountExists"] = 2] = "AccountExists";
    /**
     * Other errors, such as database write errors.
     *
     * @generated from protobuf enum value: Error = 3;
     */
    CreateUserResponse_CreateUserStatus[CreateUserResponse_CreateUserStatus["Error"] = 3] = "Error";
})(CreateUserResponse_CreateUserStatus || (CreateUserResponse_CreateUserStatus = {}));
/**
 * @generated from protobuf enum aware.GetUserFaceRecognitionModelResponse.GetUserFaceRecognitionModelStatus
 */
export var GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus;
(function (GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus) {
    /**
     * @generated from protobuf enum value: UnknownStatus = 0;
     */
    GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus[GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus["UnknownStatus"] = 0] = "UnknownStatus";
    /**
     * @generated from protobuf enum value: Success = 1;
     */
    GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus[GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus["Success"] = 1] = "Success";
    /**
     * Account does not exist
     *
     * @generated from protobuf enum value: UserNotFound = 2;
     */
    GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus[GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus["UserNotFound"] = 2] = "UserNotFound";
    /**
     * Account exists, face model does not
     *
     * @generated from protobuf enum value: FaceModelNotFound = 3;
     */
    GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus[GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus["FaceModelNotFound"] = 3] = "FaceModelNotFound";
})(GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus || (GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus = {}));
/**
 * @generated from protobuf enum aware.AddUserPlaceResponse.AddUserPlaceStatus
 */
export var AddUserPlaceResponse_AddUserPlaceStatus;
(function (AddUserPlaceResponse_AddUserPlaceStatus) {
    /**
     * @generated from protobuf enum value: UnknownStatus = 0;
     */
    AddUserPlaceResponse_AddUserPlaceStatus[AddUserPlaceResponse_AddUserPlaceStatus["UnknownStatus"] = 0] = "UnknownStatus";
    /**
     * @generated from protobuf enum value: Success = 1;
     */
    AddUserPlaceResponse_AddUserPlaceStatus[AddUserPlaceResponse_AddUserPlaceStatus["Success"] = 1] = "Success";
    /**
     * @generated from protobuf enum value: InvalidArgument = 2;
     */
    AddUserPlaceResponse_AddUserPlaceStatus[AddUserPlaceResponse_AddUserPlaceStatus["InvalidArgument"] = 2] = "InvalidArgument";
})(AddUserPlaceResponse_AddUserPlaceStatus || (AddUserPlaceResponse_AddUserPlaceStatus = {}));
/**
 * @generated from protobuf enum aware.LogLevel
 */
export var LogLevel;
(function (LogLevel) {
    /**
     * @generated from protobuf enum value: LogLevelUnknown = 0;
     */
    LogLevel[LogLevel["LogLevelUnknown"] = 0] = "LogLevelUnknown";
    /**
     * @generated from protobuf enum value: LogLevelError = 1;
     */
    LogLevel[LogLevel["LogLevelError"] = 1] = "LogLevelError";
    /**
     * @generated from protobuf enum value: LogLevelWarn = 2;
     */
    LogLevel[LogLevel["LogLevelWarn"] = 2] = "LogLevelWarn";
    /**
     * @generated from protobuf enum value: LogLevelInfo = 3;
     */
    LogLevel[LogLevel["LogLevelInfo"] = 3] = "LogLevelInfo";
    /**
     * @generated from protobuf enum value: LogLevelDebug = 4;
     */
    LogLevel[LogLevel["LogLevelDebug"] = 4] = "LogLevelDebug";
    /**
     * @generated from protobuf enum value: LogLevelTrace = 5;
     */
    LogLevel[LogLevel["LogLevelTrace"] = 5] = "LogLevelTrace";
})(LogLevel || (LogLevel = {}));
/**
 * @generated from protobuf enum aware.OptimizationStatus
 */
export var OptimizationStatus;
(function (OptimizationStatus) {
    /**
     * @generated from protobuf enum value: OptimizationStatusUnknown = 0;
     */
    OptimizationStatus[OptimizationStatus["OptimizationStatusUnknown"] = 0] = "OptimizationStatusUnknown";
    /**
     * Optimzer converged successfully
     *
     * @generated from protobuf enum value: Converged = 1;
     */
    OptimizationStatus[OptimizationStatus["Converged"] = 1] = "Converged";
    /**
     * Optimizer completed without exception, but did not converge
     *
     * @generated from protobuf enum value: NotConverged = 2;
     */
    OptimizationStatus[OptimizationStatus["NotConverged"] = 2] = "NotConverged";
    /**
     * This exception is common, so we handle it explicitly.
     *
     * @generated from protobuf enum value: IndeterminantLinearSystem = 3;
     */
    OptimizationStatus[OptimizationStatus["IndeterminantLinearSystem"] = 3] = "IndeterminantLinearSystem";
    /**
     * Other exception
     *
     * @generated from protobuf enum value: Exception = 4;
     */
    OptimizationStatus[OptimizationStatus["Exception"] = 4] = "Exception";
    /**
     * @generated from protobuf enum value: CompletedAlreadyBelowErrorTolerance = 5;
     */
    OptimizationStatus[OptimizationStatus["CompletedAlreadyBelowErrorTolerance"] = 5] = "CompletedAlreadyBelowErrorTolerance";
    /**
     * Terminated early due to error increase
     *
     * @generated from protobuf enum value: TerminatedEarlyErrorIncrease = 6;
     */
    OptimizationStatus[OptimizationStatus["TerminatedEarlyErrorIncrease"] = 6] = "TerminatedEarlyErrorIncrease";
})(OptimizationStatus || (OptimizationStatus = {}));
/**
 * @generated from protobuf enum aware.ContainerContentType
 */
export var ContainerContentType;
(function (ContainerContentType) {
    /**
     * @generated from protobuf enum value: UnknownContentType = 0;
     */
    ContainerContentType[ContainerContentType["UnknownContentType"] = 0] = "UnknownContentType";
    /**
     * @generated from protobuf enum value: ProtoBinary = 1;
     */
    ContainerContentType[ContainerContentType["ProtoBinary"] = 1] = "ProtoBinary";
    /**
     * @generated from protobuf enum value: ProtoJson = 2;
     */
    ContainerContentType[ContainerContentType["ProtoJson"] = 2] = "ProtoJson";
    /**
     * @generated from protobuf enum value: ProtoBinaryEncrypted = 3;
     */
    ContainerContentType[ContainerContentType["ProtoBinaryEncrypted"] = 3] = "ProtoBinaryEncrypted";
    /**
     * @generated from protobuf enum value: ProtoJsonEncrypted = 4;
     */
    ContainerContentType[ContainerContentType["ProtoJsonEncrypted"] = 4] = "ProtoJsonEncrypted";
})(ContainerContentType || (ContainerContentType = {}));
// @generated message type with reflection information, may provide speed optimized methods
class UserPerceptionUpdate$Type extends MessageType {
    constructor() {
        super("aware.UserPerceptionUpdate", [
            { no: 1, name: "update_time", kind: "message", T: () => Timestamp },
            { no: 2, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "location_measurements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LocationMeasurement },
            { no: 4, name: "location_visits", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LocationVisit },
            { no: 5, name: "sleep_events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SleepEvent },
            { no: 6, name: "workouts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Workout },
            { no: 10, name: "computer_sessions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ComputerSession },
            { no: 100, name: "update_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserPerceptionUpdate
 */
export const UserPerceptionUpdate = new UserPerceptionUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserPerceptionUpdateResponse$Type extends MessageType {
    constructor() {
        super("aware.UserPerceptionUpdateResponse", [
            { no: 1, name: "update_uid_ack", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserPerceptionUpdateResponse
 */
export const UserPerceptionUpdateResponse = new UserPerceptionUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserPerceptionUpdateRequest$Type extends MessageType {
    constructor() {
        super("aware.UserPerceptionUpdateRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "end_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserPerceptionUpdateRequest
 */
export const UserPerceptionUpdateRequest = new UserPerceptionUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserTimelineInformation$Type extends MessageType {
    constructor() {
        super("aware.UserTimelineInformation", [
            { no: 1, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 2, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "temporal_resolution", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserTimelineInformation
 */
export const UserTimelineInformation = new UserTimelineInformation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserTimeline$Type extends MessageType {
    constructor() {
        super("aware.UserTimeline", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timeline_information", kind: "message", T: () => UserTimelineInformation },
            { no: 3, name: "geolocations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Geolocation },
            { no: 6, name: "geolocation_velocities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GeolocationVelocity },
            { no: 4, name: "activities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActivityCategoryEstimate },
            { no: 5, name: "events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserTimeline
 */
export const UserTimeline = new UserTimeline$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserSurfaceState$Type extends MessageType {
    constructor() {
        super("aware.UserSurfaceState", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "latest_surface_connection", kind: "message", T: () => Timestamp },
            { no: 4, name: "latest_surface_presence", kind: "message", T: () => Timestamp },
            { no: 5, name: "latest_surface_engagement", kind: "message", T: () => Timestamp },
            { no: 6, name: "surface_info", kind: "message", T: () => SurfaceInfo },
            { no: 100, name: "latest_update", kind: "message", T: () => UserPerceptionUpdate }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserSurfaceState
 */
export const UserSurfaceState = new UserSurfaceState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserSurfaceEvent$Type extends MessageType {
    constructor() {
        super("aware.UserSurfaceEvent", [
            { no: 1, name: "surface_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserSurfaceEvent
 */
export const UserSurfaceEvent = new UserSurfaceEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserSurfaceEvents$Type extends MessageType {
    constructor() {
        super("aware.UserSurfaceEvents", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "surfaces", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserSurfaceState }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserSurfaceEvents
 */
export const UserSurfaceEvents = new UserSurfaceEvents$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserState$Type extends MessageType {
    constructor() {
        super("aware.UserState", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "last_observed_timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "geolocation", kind: "message", T: () => Geolocation },
            { no: 14, name: "place", kind: "message", T: () => Place },
            { no: 5, name: "events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event },
            { no: 13, name: "active_events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event },
            { no: 6, name: "futures", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserFuture },
            { no: 7, name: "utc_offset", kind: "message", T: () => Duration },
            { no: 8, name: "user_schedule", kind: "message", T: () => UserSchedule },
            { no: 12, name: "user_schedule_status", kind: "message", T: () => UserScheduleStatus },
            { no: 9, name: "event_log", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EventOperation },
            { no: 10, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "message_type", kind: "enum", T: () => ["aware.UserState.Type", UserState_Type] },
            { no: 100, name: "surfaces", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserSurfaceState },
            { no: 101, name: "realtime_status", kind: "message", T: () => UserRealtimeStatus }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserState
 */
export const UserState = new UserState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserRealtimeStatus$Type extends MessageType {
    constructor() {
        super("aware.UserRealtimeStatus", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "stamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "current_activities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActivityEstimate }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserRealtimeStatus
 */
export const UserRealtimeStatus = new UserRealtimeStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserTimelineRequest$Type extends MessageType {
    constructor() {
        super("aware.UserTimelineRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "end_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserTimelineRequest
 */
export const UserTimelineRequest = new UserTimelineRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetUserTimelineResponse$Type extends MessageType {
    constructor() {
        super("aware.ResetUserTimelineResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message aware.ResetUserTimelineResponse
 */
export const ResetUserTimelineResponse = new ResetUserTimelineResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServerStatusRequest$Type extends MessageType {
    constructor() {
        super("aware.ServerStatusRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message aware.ServerStatusRequest
 */
export const ServerStatusRequest = new ServerStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServerStatusResponse$Type extends MessageType {
    constructor() {
        super("aware.ServerStatusResponse", [
            { no: 1, name: "user_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "geocoding_status", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "routing_status", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "version_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "database_status", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 101, name: "user_state_streams_status", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StreamMetadata }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ServerStatusResponse
 */
export const ServerStatusResponse = new ServerStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamMetadata$Type extends MessageType {
    constructor() {
        super("aware.StreamMetadata", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "peer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "stream_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "stream_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "stream_start_time", kind: "message", T: () => Timestamp },
            { no: 6, name: "last_message_sent_time", kind: "message", T: () => Timestamp },
            { no: 7, name: "stream_end_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.StreamMetadata
 */
export const StreamMetadata = new StreamMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserFutureRequest$Type extends MessageType {
    constructor() {
        super("aware.UserFutureRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserFutureRequest
 */
export const UserFutureRequest = new UserFutureRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserFutureResponse$Type extends MessageType {
    constructor() {
        super("aware.UserFutureResponse", [
            { no: 1, name: "futures", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserFuture }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserFutureResponse
 */
export const UserFutureResponse = new UserFutureResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserFuture$Type extends MessageType {
    constructor() {
        super("aware.UserFuture", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Event },
            { no: 3, name: "future_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "updated_timestamp", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserFuture
 */
export const UserFuture = new UserFuture$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserPerceptionUpdateList$Type extends MessageType {
    constructor() {
        super("aware.UserPerceptionUpdateList", [
            { no: 1, name: "updates", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserPerceptionUpdate },
            { no: 100, name: "update_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserPerceptionUpdateList
 */
export const UserPerceptionUpdateList = new UserPerceptionUpdateList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Factor$Type extends MessageType {
    constructor() {
        super("aware.Factor", [
            { no: 1, name: "keys", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Key },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "error", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.Factor
 */
export const Factor = new Factor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Value$Type extends MessageType {
    constructor() {
        super("aware.Value", [
            { no: 1, name: "key", kind: "message", T: () => Key },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 12, name: "double_values", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.Value
 */
export const Value = new Value$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Key$Type extends MessageType {
    constructor() {
        super("aware.Key", [
            { no: 1, name: "key", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "symbol_char", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "symbol_label", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "symbol_index", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.Key
 */
export const Key = new Key$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OptimizationMetadata$Type extends MessageType {
    constructor() {
        super("aware.OptimizationMetadata", [
            { no: 1, name: "status", kind: "enum", T: () => ["aware.OptimizationStatus", OptimizationStatus] },
            { no: 2, name: "optimizer_error", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "completion_timestamp", kind: "message", T: () => Timestamp },
            { no: 4, name: "optimization_duration", kind: "message", T: () => Duration },
            { no: 100, name: "exception_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 101, name: "exception_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.OptimizationMetadata
 */
export const OptimizationMetadata = new OptimizationMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OptimizationResult$Type extends MessageType {
    constructor() {
        super("aware.OptimizationResult", [
            { no: 1, name: "values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Value },
            { no: 2, name: "factors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Factor },
            { no: 3, name: "metadata", kind: "message", T: () => OptimizationMetadata },
            { no: 100, name: "graph_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 101, name: "values_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 102, name: "error_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.OptimizationResult
 */
export const OptimizationResult = new OptimizationResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AwareEnginePluginConfiguration$Type extends MessageType {
    constructor() {
        super("aware.AwareEnginePluginConfiguration", [
            { no: 1, name: "use_geolocation", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "use_geolocation_velocity", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "use_activity_categories", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "use_calendar_precog", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.AwareEnginePluginConfiguration
 */
export const AwareEnginePluginConfiguration = new AwareEnginePluginConfiguration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AwareEngineUserConfiguration$Type extends MessageType {
    constructor() {
        super("aware.AwareEngineUserConfiguration", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "plugin_config", kind: "message", T: () => AwareEnginePluginConfiguration },
            { no: 3, name: "aware_space_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 101, name: "log_level", kind: "enum", T: () => ["aware.LogLevel", LogLevel] },
            { no: 102, name: "developer_flags", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 8 /*ScalarType.BOOL*/ } },
            { no: 103, name: "default_timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.AwareEngineUserConfiguration
 */
export const AwareEngineUserConfiguration = new AwareEngineUserConfiguration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AwareEngineServerConfiguration$Type extends MessageType {
    constructor() {
        super("aware.AwareEngineServerConfiguration", [
            { no: 1, name: "profile_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 1000, name: "database_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 1001, name: "save_to_database", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 1002, name: "save_to_file", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 1004, name: "init_from_database", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 1006, name: "init_from_database_generate_interval_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1005, name: "init_latest_timeline_from_database", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 1003, name: "user_uid_filter", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.AwareEngineServerConfiguration
 */
export const AwareEngineServerConfiguration = new AwareEngineServerConfiguration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventConstraintsResponse$Type extends MessageType {
    constructor() {
        super("aware.EventConstraintsResponse", [
            { no: 1, name: "result", kind: "enum", T: () => ["aware.EventConstraintsResponse.CSPResult", EventConstraintsResponse_CSPResult] },
            { no: 2, name: "error_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.EventConstraintsResponse
 */
export const EventConstraintsResponse = new EventConstraintsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUserRequest$Type extends MessageType {
    constructor() {
        super("aware.CreateUserRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.CreateUserRequest
 */
export const CreateUserRequest = new CreateUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateUserResponse$Type extends MessageType {
    constructor() {
        super("aware.CreateUserResponse", [
            { no: 1, name: "result", kind: "enum", T: () => ["aware.CreateUserResponse.CreateUserStatus", CreateUserResponse_CreateUserStatus] },
            { no: 2, name: "error_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.CreateUserResponse
 */
export const CreateUserResponse = new CreateUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserFaceRecognitionModelRequest$Type extends MessageType {
    constructor() {
        super("aware.GetUserFaceRecognitionModelRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.GetUserFaceRecognitionModelRequest
 */
export const GetUserFaceRecognitionModelRequest = new GetUserFaceRecognitionModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserFaceRecognitionModelResponse$Type extends MessageType {
    constructor() {
        super("aware.GetUserFaceRecognitionModelResponse", [
            { no: 1, name: "status", kind: "enum", T: () => ["aware.GetUserFaceRecognitionModelResponse.GetUserFaceRecognitionModelStatus", GetUserFaceRecognitionModelResponse_GetUserFaceRecognitionModelStatus] },
            { no: 2, name: "model", kind: "message", T: () => FaceRecognitionModel },
            { no: 3, name: "error_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.GetUserFaceRecognitionModelResponse
 */
export const GetUserFaceRecognitionModelResponse = new GetUserFaceRecognitionModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveUserFaceRecognitionModelRequest$Type extends MessageType {
    constructor() {
        super("aware.SaveUserFaceRecognitionModelRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "face_model", kind: "message", T: () => FaceRecognitionModel }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.SaveUserFaceRecognitionModelRequest
 */
export const SaveUserFaceRecognitionModelRequest = new SaveUserFaceRecognitionModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SaveUserFaceRecognitionModelResponse$Type extends MessageType {
    constructor() {
        super("aware.SaveUserFaceRecognitionModelResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message aware.SaveUserFaceRecognitionModelResponse
 */
export const SaveUserFaceRecognitionModelResponse = new SaveUserFaceRecognitionModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddUserPlaceResponse$Type extends MessageType {
    constructor() {
        super("aware.AddUserPlaceResponse", [
            { no: 1, name: "status", kind: "enum", T: () => ["aware.AddUserPlaceResponse.AddUserPlaceStatus", AddUserPlaceResponse_AddUserPlaceStatus] },
            { no: 2, name: "error_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.AddUserPlaceResponse
 */
export const AddUserPlaceResponse = new AddUserPlaceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddUserPersonResponse$Type extends MessageType {
    constructor() {
        super("aware.AddUserPersonResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message aware.AddUserPersonResponse
 */
export const AddUserPersonResponse = new AddUserPersonResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserPlotDataRequest$Type extends MessageType {
    constructor() {
        super("aware.UserPlotDataRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "activity_type", kind: "enum", T: () => ["aware.ActivityCategoryType", ActivityCategoryType] },
            { no: 3, name: "intervals", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PlotDataInterval }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserPlotDataRequest
 */
export const UserPlotDataRequest = new UserPlotDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlotDataPoint$Type extends MessageType {
    constructor() {
        super("aware.PlotDataPoint", [
            { no: 1, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "data_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.PlotDataPoint
 */
export const PlotDataPoint = new PlotDataPoint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlotDataInterval$Type extends MessageType {
    constructor() {
        super("aware.PlotDataInterval", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "end", kind: "message", T: () => Timestamp },
            { no: 3, name: "points", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PlotDataPoint }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.PlotDataInterval
 */
export const PlotDataInterval = new PlotDataInterval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserPlotData$Type extends MessageType {
    constructor() {
        super("aware.UserPlotData", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "intervals", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PlotDataInterval }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.UserPlotData
 */
export const UserPlotData = new UserPlotData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DatabaseInsertRequest$Type extends MessageType {
    constructor() {
        super("aware.DatabaseInsertRequest", [
            { no: 1, name: "request_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "collection_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "owner_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "message_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "object", kind: "message", T: () => DatabaseContainerObject }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.DatabaseInsertRequest
 */
export const DatabaseInsertRequest = new DatabaseInsertRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DatabaseQueryRequest$Type extends MessageType {
    constructor() {
        super("aware.DatabaseQueryRequest", [
            { no: 1, name: "request_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "collection_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "owner_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 5, name: "end_date", kind: "message", T: () => Timestamp },
            { no: 6, name: "message_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.DatabaseQueryRequest
 */
export const DatabaseQueryRequest = new DatabaseQueryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DatabaseContainerObject$Type extends MessageType {
    constructor() {
        super("aware.DatabaseContainerObject", [
            { no: 1, name: "owner_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "message_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "start_date", kind: "message", T: () => Timestamp },
            { no: 3, name: "end_date", kind: "message", T: () => Timestamp },
            { no: 4, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 6, name: "content_type", kind: "enum", T: () => ["aware.ContainerContentType", ContainerContentType] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.DatabaseContainerObject
 */
export const DatabaseContainerObject = new DatabaseContainerObject$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DatabaseInsertResponse$Type extends MessageType {
    constructor() {
        super("aware.DatabaseInsertResponse", [
            { no: 1, name: "insert_ack_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.DatabaseInsertResponse
 */
export const DatabaseInsertResponse = new DatabaseInsertResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DatabaseQueryResponse$Type extends MessageType {
    constructor() {
        super("aware.DatabaseQueryResponse", [
            { no: 1, name: "ack_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "objects", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DatabaseContainerObject }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.DatabaseQueryResponse
 */
export const DatabaseQueryResponse = new DatabaseQueryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimezoneResponse$Type extends MessageType {
    constructor() {
        super("aware.TimezoneResponse", [
            { no: 1, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "error", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "error_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.TimezoneResponse
 */
export const TimezoneResponse = new TimezoneResponse$Type();
/**
 * @generated ServiceType for protobuf service aware.AwareEngineService
 */
export const AwareEngineService = new ServiceType("aware.AwareEngineService", [
    { name: "handleUserPerceptionUpdate", options: {}, I: UserPerceptionUpdate, O: UserPerceptionUpdateResponse },
    { name: "handleUserPerceptionUpdateList", options: {}, I: UserPerceptionUpdateList, O: UserPerceptionUpdateResponse },
    { name: "getUserTimeline", options: {}, I: UserTimelineRequest, O: UserTimeline },
    { name: "getPastUserTimeline", options: {}, I: UserTimelineRequest, O: UserTimeline },
    { name: "generateUserTimeline", options: {}, I: UserTimelineRequest, O: UserTimeline },
    { name: "getLatestObservedState", options: {}, I: UserTimelineRequest, O: UserState },
    { name: "getFutures", options: {}, I: UserFutureRequest, O: UserFutureResponse },
    { name: "getUserCache", options: {}, I: UserTimelineRequest, O: UserPerceptionUpdateList },
    { name: "resetUserTimeline", options: {}, I: UserTimelineRequest, O: ResetUserTimelineResponse },
    { name: "getServerStatus", options: {}, I: ServerStatusRequest, O: ServerStatusResponse },
    { name: "streamUserState", serverStreaming: true, options: {}, I: UserTimelineRequest, O: UserState },
    { name: "sendEventConstraints", options: {}, I: EventConstraints, O: EventConstraintsResponse },
    { name: "streamUserSchedule", serverStreaming: true, options: {}, I: UserTimelineRequest, O: UserSchedule },
    { name: "getUserPlotData", options: {}, I: UserPlotDataRequest, O: UserPlotData },
    { name: "createUser", options: {}, I: CreateUserRequest, O: CreateUserResponse },
    { name: "getUserFaceRecognitionModel", options: {}, I: GetUserFaceRecognitionModelRequest, O: GetUserFaceRecognitionModelResponse },
    { name: "saveUserFaceRecognitionModel", options: {}, I: FaceRecognitionModel, O: SaveUserFaceRecognitionModelResponse },
    { name: "getUserLocationStatistics", options: {}, I: UserTimelineRequest, O: UserLocationStatistics },
    { name: "getUserActivityStatistics", options: {}, I: UserTimelineRequest, O: UserActivityStatisticsList },
    { name: "getActivityInsights", options: {}, I: UserTimelineRequest, O: ActivityInsights },
    { name: "getUserPlaces", options: {}, I: UserTimelineRequest, O: UserPlaces },
    { name: "addUserPlace", options: {}, I: Place, O: AddUserPlaceResponse },
    { name: "getUserPersons", options: {}, I: UserTimelineRequest, O: UserPersons },
    { name: "addUserPerson", options: {}, I: Person, O: AddUserPersonResponse },
    { name: "recomputeUserStatistics", options: {}, I: UserTimelineRequest, O: UserLocationStatistics },
    { name: "scheduleReminder", options: {}, I: ScheduleReminderRequest, O: ScheduleReminderResponse },
    { name: "deleteReminder", options: {}, I: DeleteReminderRequest, O: ScheduleReminderResponse }
]);
/**
 * @generated ServiceType for protobuf service aware.AwareEngineDatabaseInterfaceService
 */
export const AwareEngineDatabaseInterfaceService = new ServiceType("aware.AwareEngineDatabaseInterfaceService", [
    { name: "saveUserPerceptionUpdate", options: {}, I: UserPerceptionUpdate, O: UserPerceptionUpdateResponse },
    { name: "getUserPerceptionUpdates", options: {}, I: UserPerceptionUpdateRequest, O: UserPerceptionUpdateList },
    { name: "getServerStatus", options: {}, I: ServerStatusRequest, O: ServerStatusResponse },
    { name: "insertProto", options: {}, I: DatabaseInsertRequest, O: DatabaseInsertResponse },
    { name: "getProto", options: {}, I: DatabaseQueryRequest, O: DatabaseQueryResponse },
    { name: "getProtos", options: {}, I: DatabaseQueryRequest, O: DatabaseQueryResponse },
    { name: "streamProtos", serverStreaming: true, options: {}, I: DatabaseQueryRequest, O: DatabaseContainerObject }
]);
/**
 * @generated ServiceType for protobuf service aware.CryptoService
 */
export const CryptoService = new ServiceType("aware.CryptoService", [
    { name: "encryptProto", options: {}, I: DatabaseContainerObject, O: DatabaseContainerObject },
    { name: "decryptProto", options: {}, I: DatabaseContainerObject, O: DatabaseContainerObject }
]);
/**
 * @generated ServiceType for protobuf service aware.TimezoneService
 */
export const TimezoneService = new ServiceType("aware.TimezoneService", [
    { name: "getTimezone", options: {}, I: Geolocation, O: TimezoneResponse }
]);
